// Business identity + base location — single source for the website copy, the footer and the
// site-wide Locksmith JSON-LD (scripts/materialize-routes.js). CommonJS so the Node build script can
// require it; React imports it like any other module.
//
// Keep every field identical to the Google Business Profile (name, phone, base, hours) — Google
// trusts listings whose details match the website.

const business = {
  name: 'Shore Doors Locksmiths',
  // Hugh, 26 Sep 2026: the business is based in Greenhithe (Upper Harbour, North Shore).
  baseSuburb: 'Greenhithe',
  postcode: '0632',
  city: 'Auckland',
  // Greenhithe workshop: key cutting and collections (Hugh, 26 Sep 2026: open Mon–Fri 9am–5pm).
  // open drives the "come to us" copy. streetAddress is published on the site and in the JSON-LD
  // once filled in, so it must match the Google Business Profile word for word; until then the site
  // says "our Greenhithe workshop" and the JSON-LD stays at suburb level.
  workshop: {
    open: true,
    streetAddress: '1 Thomas Hamer Place', // Hugh, 26 Sep 2026 — same wording on the Google profile
    hoursLine: 'Mon–Fri 9:00am – 5:00pm',
    // → the workshop department's JSON-LD hours. The Google profile itself is "Open 24 hours" with
    // the address stored but hidden (Hugh, 26 Sep 2026: 24/7 lockouts; Google only lets a SHOWN
    // address list hours when it's staffed for customers, and council caps home-workshop visits
    // at 7am–7pm).
    opens: '09:00',
    closes: '17:00',
  },
  // Google Business Profile (Maps place ID link, stable) → JSON-LD sameAs/hasMap + footer link.
  googleProfileUrl: 'https://www.google.com/maps?cid=10051304565606154499',
};

module.exports = { business };
